import React from 'react'
import classnames from 'classnames'
import { Pill } from '@myxplor/ui'
import { lastWord, titleise } from '../../text-transformations'
import { recordIsActive } from './helpers'

const RecordBadges = ({ record }) => {
  const isActive = recordIsActive(record)
  return <Pill warning={!isActive}>{recordIsActive(record) ? 'Active' : 'Inactive'}</Pill>
}

const Badges = ({ recordBadgesComponent = RecordBadges, record }) => (
  recordBadgesComponent ?
    <div className="recordDisplayList--badges">
      {React.createElement(recordBadgesComponent, { record })}
    </div> :
    null
)

const ActionButtons = ({ actionButtonsComponent, record, children }) => (
  actionButtonsComponent ?
    React.createElement(actionButtonsComponent, { record }, children) :
    children
)

const DisplayRecordItem = ({
  record,
  recordsTotal,
  count,
  name,
  actionButtonsComponent,
  recordBadgesComponent,
  pending = () => (false),
  children
}) => (
  <li
    className={classnames({
      'recordDisplayList--item': true,
      'recordDisplayList--item__pending': pending(record),
      'inactiveRecord': record.inactive
    })}
  >

    <div className="recordDisplayList--heading">

      <ActionButtons
        actionButtonsComponent={actionButtonsComponent}
        record={record}
      >
        <h3>{titleise(lastWord(name))} {count} of {recordsTotal}</h3>
      </ActionButtons>

      <Badges recordBadgesComponent={recordBadgesComponent} record={record} />
    </div>

    {children}
  </li>

)

export default DisplayRecordItem


// WEBPACK FOOTER //
// ./src/ui/record-display-list/item.jsx